<template>
  <div class="container">
    <img class="succeed_icon" src="../../../assets/ic_succeed@2x.png" />
    <h1 class="title">报名成功</h1>
    <div class="add_hint">请您添加活动的客户群，班级管理员将在群内通知活动相关安排。</div>
    <Qrcode class="qrcode" :src="adviser.wechatGroupImg" :tracker="tracker" :meta="meta" />
    <div class="hint">长按识别二维码，添加活动客户群</div>
  </div>
</template>
<script>
import { PAGE_EXPOSE, BUTTON_CLICK } from "../../../utils/bigDataSdk";
import Qrcode from '../../../components/Qrcode.vue'

const pageInfo = {
  pageId: "40006",
  pageName: "活动客户群二维码页",
  pageTilte: "报名成功",
};

export default {
  props: {
    tracker: Function,
  },
  components:{
    Qrcode
  },
  mounted() {
    setTimeout(() => {
      this.tracker({
        eventKey: PAGE_EXPOSE,
        ...pageInfo,
      });
    }, 0);
  },
  computed: {
    adviser() {
      return this.$store.state.activity.config || {};
    },
    meta(){
      return  {
        buttonName: '二维码长按',
        buttonContent: '二维码长按'
      };
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  text-align: center;
  padding: 40px;
}
.title {
  margin-top: 27px;
  font-size: 24px;
  font-weight: blod;
  color: #34404a;
  line-height: 19px;
}
.succeed_icon {
  width: 72px;
  height: 63px;
  margin-top: 45px;
}
.qrcode {
  margin-top: 52px;
  width: 150px;
  height: 150px;
}
.add_hint {
  margin: 25px auto 0;
  font-size: 16px;
  font-weight: 500;
  color: #34404a;
  width: 303px;
}
.hint {
  margin-top: 20px;
  font-size: 13px;
  font-weight: 500;
  color: #999999;
}
</style>
